module.exports = __webpack_public_path__ + "img/gagc4680_1.753aa1d3.svg";